export default {
  credential:{},
  ownerAffiliation: null,
}